import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KindService } from 'app/services/models/kind.service';
import { ReminderService } from 'app/services/models/reminder.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-reminder-dialog',
  templateUrl: './create-reminder-dialog.component.html',
  styleUrls: ['./create-reminder-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateReminderDialogComponent implements OnInit {
  createReminderForm: FormGroup;
  kinds: any = [];
  constructor(
    private activeModal: NgbActiveModal,
    private reminderService: ReminderService,
    private fb: FormBuilder,
    private kindService: KindService,
    private toatrService:ToastrService
  ) { }

  async ngOnInit() {
    this.createReminderForm = this.fb.group({
      serviceName: [null, Validators.required],
      kindId: [null, Validators.required],
      isActive: [false],
      message: [null],
      ccMail: [null],
      createReminderSettingDTOs: this.fb.array([
        this.createReminderSetting()  // başlangıçta 1 satır
      ])
    });
    await this.getAllKinds();
  }

  createReminderSetting(): FormGroup {
    return this.fb.group({
      daysBefore: [1, Validators.required],
      timesPerDay: [1, Validators.required]
    });
  }

  get createReminderSettings(): FormArray {
    return this.createReminderForm.get('createReminderSettingDTOs') as FormArray;
  }

  addSetting() {
    this.createReminderSettings.push(this.createReminderSetting());
  }

  removeSetting(index: number) {
    if (this.createReminderSettings.length > 1) {
      this.createReminderSettings.removeAt(index);
    }
  }
  
  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 17);
    console.log(data);
    this.kinds = data.types;
  }

  onClose(result: boolean) {
    this.activeModal.close(result);
  }

  async save() {
    if (this.createReminderForm.invalid) return;

    try {
      const formValue = this.createReminderForm.value;
      console.log(formValue);
      const res = await this.reminderService.createReminder(formValue);

      if (res?.status === true) {
        this.toatrService.success(res.message);
        this.activeModal.close(true);
      } else {
        this.toatrService.error(res.message);
      }
    } catch (err) {
      console.error(err);
      this.activeModal.close(false);
    }
  }
}
